var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary--text"},[_c('div',{staticClass:"text-h4 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.stat)+" ")]),_c('div',{staticClass:"text-h6 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }